export class Task {
  id: string;
  name: string;
  taskGroupId: string;
  taskGroupName: string;
  segId?: string;
  taskAssignmentId?: string;
}

